import React from 'react';

function Home() {
  return (
    <div 
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        backgroundImage: 'url(/background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
      className='App'
    >
      <a 
        style={{
          position: 'absolute',
          top: '1.75rem',
          right: '3rem',
          color: 'black',
          textDecoration: 'none',
          fontWeight: 'normal'
        }}
        href="mailto:safamohiuddin@gmail.com"
        target="_blank"
        rel="noreferrer"
      >
        @
      </a>
        
      {/* Main content */}
      <div style={{ textAlign: 'center', transform: 'translateY(-20%)' }} className="font-serif">
        {/* Profile Picture */}
        <div className="w-32 h-32 rounded-full overflow-hidden mb-6 mx-auto bg-gray-200 flex items-center justify-center">
          <img 
            src="/safa_profile.png" 
            alt="Safa Mohiuddin"
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback to initials if image fails to load
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent) {
                parent.innerHTML = '<span class="text-4xl font-bold text-gray-600 font-serif">SM</span>';
              }
            }}
          />
        </div>
        
        <h1 
          className="font-bold text-6xl mb-2"
        >
          Safa Mohiuddin
        </h1>
        
        <p 
          className="text-lg mb-4"
        >
          Registered Nurse
        </p>
      </div>
    </div>
  );
}

export default Home;

